import secureApi from "../services/secureApi";

export const orderVerificationApi = async (payload) => {
  try {
    const response = await secureApi.post(
      "/admin-upload/order-verification",
      payload,
    );

    return response.data;
  } catch (error) {
    console.error("Order verification API error:", error);
    throw error;
  }
};
